
<template>
  <div>
    <dialog-loading v-if="saving" loadingText='Salvando...'></dialog-loading>
    <v-card flat class="d-flex flex-column elevation-0">
      <v-card-text>
        <v-stepper v-model="stepper_count" class="elevation-0">
          <v-stepper-header class="elevation-0" style="height: 100%;">
            <template v-for="(item, idx) in stepper_map">
              <v-stepper-step class="pb-3 pt-3 px-1" :step="idx" :editable="stepper_count > idx"> 
                {{ item.title }}
                <small v-if="item.small">{{item.small}}</small>
              </v-stepper-step>
            </template>
          </v-stepper-header>
          <div class="d-flex justify-center subtitle-1 font-weight-light">
            {{stepper_map[stepper_count].full_title}}
          </div>
          <v-divider class="mt-1"></v-divider>
          <v-card flat style="overflow-y: auto;">
            <v-card-text class="pa-0">
              <v-stepper-content class="pa-0" step="1">
                <v-form ref="form1">
                  <SelectModality :object_with_model="new_order" model="modality_id" :solution="['wholesale']"></SelectModality>
                </v-form>
              </v-stepper-content>
              <v-stepper-content class="pa-0" step="2">
                <v-form ref="form2">
                  <!-- <v-checkbox v-model="new_order.without_client" class="ml-2" label="Pedido sem cliente"></v-checkbox> -->
                  <ClientSelection @redo="handleRedoOrder" v-if="!new_order.without_client" @canUseClient="handleCanUseClient" :order="new_order" :modality_id="new_order.modality_id"></ClientSelection>
                </v-form>
              </v-stepper-content>
              <v-stepper-content class="pa-0" step="3">
                <v-form ref="form3">
                  <SelectSellerAndManager :manager="false" :order="new_order"></SelectSellerAndManager>
                </v-form>
              </v-stepper-content>
              <v-stepper-content class="pa-0" step="4">
                <SelectWholesaleAddress ref="form4" :order="new_order"></SelectWholesaleAddress>
              </v-stepper-content>
              <v-stepper-content class="pa-0" step="5">
                <v-form ref="form5">
                  <SelectWholesaleProducts v-if="stepper_count >= 5" :stepper_count="stepper_count" :order="new_order"></SelectWholesaleProducts>
                </v-form>
              </v-stepper-content>
              <v-stepper-content class="pa-0" step="6">
                <v-form ref="form6">
                  <SelectWholesaleOrderShipping v-if="stepper_count >= 6" :order="new_order"></SelectWholesaleOrderShipping>
                </v-form>
              </v-stepper-content>
              <v-stepper-content class="pa-0" step="7">
                <SelectWholesaleOrderPayments ref="form7" :stepper_count="stepper_count" :order="new_order"></SelectWholesaleOrderPayments>
              </v-stepper-content>
              <v-stepper-content class="pa-0" step="8">
                <v-form ref="form8">

                  <v-alert v-if="!had_limit && stepper_count == 8" color="red" type="error">
                    Valor total do pedido está acima do limite disponível do cliente. Favor entrar em contato com gerência.
                  </v-alert>
                  <v-alert v-if="!had_bonus_for_anticipated && stepper_count == 8" color="red" type="error">
                    Prazo Antecipado exige bônus suficiente. O cliente precisa ter o valor do pagamento em bônus para lançar o pedido.
                  </v-alert>
                  <FinishWholesaleOrder v-if="stepper_count >= 8" :order="new_order"></FinishWholesaleOrder>
                </v-form>
              </v-stepper-content>
            </v-card-text>

          </v-card>
        </v-stepper>
      </v-card-text>
    </v-card>
    <v-footer app class="white">
      <v-sheet class="d-flex mb-3 justify-center align-center" width="100%">
        <v-divider></v-divider>
      </v-sheet>
      <v-sheet class="d-flex mb-2 justify-center align-center" width="100%">
        <v-btn small :disabled="stepper_count == 1" @click="stepper_count--" class="mx-1 error">
          <v-icon left>mdi-arrow-left-bold-circle</v-icon>
          Anterior
        </v-btn>
        <v-btn v-if="stepper_count < last_stepper" small @click="nextStepper" class="mx-1 success">
          Avançar
          <v-icon right>mdi-arrow-right-bold-circle</v-icon>
        </v-btn>
        <v-btn v-if="stepper_count == last_stepper" :disabled="!can_create_order" small @click="createOrder" class="mx-1 success">
          <v-icon left>mdi-note-plus</v-icon>
          Criar pedido
        </v-btn>
      </v-sheet>
    </v-footer>
  </div>
</template>

<script>
import Api from '@/api/index';


export default {
  name: 'CreateWholesaleOrder',
  components: {
    ClientSelection: () => import("@/components/create_order/shared/ClientSelection.vue"),
    SelectSellerAndManager:() => import("@/components/create_order/shared/SelectSellerAndManager.vue"),
    SelectWholesaleAddress: () => import("@/components/create_order/wholesale_components/SelectWholesaleAddress.vue"),
    PaymentSelection: () => import("@/components/create_order/shared/payments/PaymentSelection.vue"),
    SelectBillingClient: () => import("@/components/create_order/wholesale_components/SelectBillingClient.vue"),
    SelectWholesaleProducts: () => import("@/components/create_order/wholesale_components/SelectWholesaleProducts.vue"),
    SelectWholesaleOrderPayments: () => import("@/components/create_order/wholesale_components/SelectWholesaleOrderPayments.vue"),
    SelectWholesaleOrderShipping: () => import("@/components/create_order/wholesale_components/SelectWholesaleOrderShipping.vue"),
    FinishWholesaleOrder: () => import("@/components/create_order/wholesale_components/FinishWholesaleOrder.vue"),
    SelectModality: () => import("@/components/shared/SelectModality.vue"),
  },
  data() {
    return {
      saving: false,
      stepper_count: 1,
      stepper_map: {
        1: {full_title: 'Região do pedido', title: 'Regiões', small: ''},
        2: {full_title: 'Cliente do pedido', title: 'Cliente', small: ''},
        3: {full_title: 'Responsáveis', title: 'Responsáveis', small: ''},
        4: {full_title: 'Endereço de entrega', title: 'Endereço', small: 'de entrega'},
        5: {full_title: 'Produto e preços', title: 'Produtos', small: 'e preços'},
        6: {full_title: 'Detalhes do frete', title: 'Detalhes', small: 'do frete'},
        7: {full_title: 'Pagamentos', title: 'Pagamentos', small: ''},
        8: {full_title: 'Revisar pedido', title: 'Revisar', small: 'pedido'},
      },
      can_use_client: true,
      all_pay_times: [],
      new_order: {
        client_wants_email: "dont_want",
        without_client: false,
        client_id: null,
        modality_id: null,
        employee_id: null,
        manager_id: null,
        logistic_id: null,
        segment_id: null,
        bag_sell_price: null,
        total_order_price: null,
        bag_shipping_price: '0.0000',
        order_shipping_price_aux: null,
        order_shipping_price: null,
        pickup_location_id: null,
        product_pickup_location_id: null,
        total_bags: null,
        order_status: 'to_approve',
        total_order_buy: 0,
        total_order_sell: 0,
        total_order_bags: 0,
        comment: null,
        client: {},         
        pickup_location: {},         
        items_attributes: [{ unit_shipping_price: '0.00' }],
        client_shipping_location_attributes: { 
          client_id: null,
          address_id: null,
          building_id: null,
          address_attributes: null,
          building_attributes: null,
        },
        shipping: { 
          address_id: null, 
          building_id: null,
          building: {
            id: null
          },
          building_attributes: {
            address_attributes: {
              zip: null,
              addr: null,
              neighborhood: null,
              number: null,
              complement: null,
              city: null,
              state: null,
             }
          },
        },
        truck: null,
        driver: null,
              
        delivery_attributes: {
          estimatedLoading: null,
          internal: false,
          driver_commission: null,
          driver_id: null,
          quantity_of_pallets: 0,
          needs_pallets: null,
        },
        payments:{
          list:[],
          has_cash: false,
          has_deposit: false,
        },
        solution: 'wholesale'
      },
    }
  },
  computed:{
    last_stepper(){
      return Object.keys(this.stepper_map).length
    },
    had_limit(){
      if(this.stepper_count == 8){

        if( this.new_order.client ){
          let client_limit = this.new_order.client.credits?.data?.attributes?.limit ? this.new_order.client.credits?.data?.attributes?.limit : this.new_order.client.client_credit?.limit
                    
          let payment_options = this.new_order.payments.list.filter(el =>![1, 6].includes(el.payment_option_id) && ![3].includes(el.payment_time_id))
          let total_invoice_without_money = payment_options.length == 0 ? 0 : parseFloat(payment_options.map(el=> el.ammount.replace(',', '')).reduce((accumulator, current) => (accumulator) + current)) 

          return parseFloat(client_limit) >= parseFloat(total_invoice_without_money) 
        }else{
          return true
        }
          
      }
    },
    anticipated_payment_time_ids() {
      return this.all_pay_times
        .filter(time => time.attributes?.anticipated)
        .map(time => parseInt(time.id))
    },
    anticipated_payments_total() {
      if (!this.new_order.payments?.list?.length || !this.anticipated_payment_time_ids.length) return 0

      return this.new_order.payments.list
        .filter(el => this.anticipated_payment_time_ids.includes(parseInt(el.payment_time_id)))
        .reduce((acc, el) => acc + parseFloat(String(el.ammount).replace(/,/g, '') || 0), 0)
    },
    client_bonus() {
      const credits = this.new_order.client?.credits?.data?.attributes
      const client_credit = this.new_order.client?.client_credit
      return parseFloat(credits?.bonus ?? client_credit?.bonus ?? 0)
    },
    had_bonus_for_anticipated() {
      if (this.stepper_count != 8) return true
      if (this.anticipated_payments_total <= 0) return true
      return this.client_bonus >= this.anticipated_payments_total
    },
    can_create_order() {
      return this.had_limit && this.had_bonus_for_anticipated
    },
    isMobile(){
      return this.$vuetify.breakpoint.mdAndDown
    },
  },
  methods: {
    handleCanUseClient(can){
      this.can_use_client = can
    },
    handleRedoOrder(order){
      this.new_order = {...this.new_order, ...order}
      this.stepper_count = 3
    },
    handleWithoutClient(){
      this.new_order.client_id = null
      this.new_order.client_name = null
      this.new_order.manager_id = null
      this.new_order.employee_id = null
      this.new_order.client = null
      this.new_order.delivery_attributes.internal = false
      this.new_order.payments.list = [
          {
            payment_option_id: null,
            payment_time_id: null,
            ammount: '0.00',
            percentage: 100,
            ref: Math.round(Math.random()*10000),
          }
        ]
    },
    nextStepper(){
      if(this.validateStepper(this.stepper_count)){
        this.stepper_count++;
      }
    },
    validateStepper(stepper){
      if( this.$refs[`form${stepper}`]?.validate()){
        return true
      }else{
        this.missingFields()
        return false
      }
    },
    prepareShipping(){
      this.new_order.client_shipping_location_attributes.address_id = null
      this.new_order.client_shipping_location_attributes.address_attributes = null
      this.new_order.client_shipping_location_attributes.building_attributes = null
      this.new_order.client_shipping_location_attributes.client_id = null
      // Se tiver cliente, se n tiver manda tudo null
      if(!this.new_order.without_client){
        this.new_order.client_shipping_location_attributes.client_id = this.new_order.client_id
        if(this.new_order.client_shipping_location_attributes.building_id){
          //  Se for refazer pedido
        }else if(this.new_order.shipping.building?.id){
          this.new_order.client_shipping_location_attributes.building_id = this.new_order.shipping.building?.id
        }else{
          this.new_order.client_shipping_location_attributes.building_attributes = this.new_order.shipping?.building_attributes
          this.new_order.client_shipping_location_attributes.building_attributes.client_id = this.new_order.client_id
          this.new_order.client_shipping_location_attributes.building_id = null
        }
      }
    },
    prepareDriverTruck() {
      if (this.new_order.driver?.id && this.new_order.truck?.id) {
        this.new_order.delivery_attributes.driver_id = this.new_order.driver.id
        this.new_order.delivery_attributes.truck_id = this.new_order.truck.id
        this.new_order.delivery_attributes.truck_plate =
          this.new_order.truck.plate || this.new_order.truck.attributes?.plate
      }
    },
    parseEstimatedLoadingToIso(dateStr) {
      if (!dateStr) return null
      const [day, month, year] = dateStr.split('/')
      if (!day || !month || !year) return null
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    prepareDeliveryData() {
      const attrs = this.new_order.delivery_attributes || {}
      const driverAttrs = this.new_order.driver?.attributes || this.new_order.driver || {}
      const payment = attrs.payment_method
        || driverAttrs.receipt_config?.kind
        || (driverAttrs.receipt_config?.kinds && driverAttrs.receipt_config.kinds[0])
        || null
      this.new_order.delivery_data_attributes = {
        internal: !!attrs.internal,
        driver_id: attrs.driver_id || null,
        truck_id: attrs.truck_id || null,
        truck_plate: attrs.truck_plate || null,
        estimated_loading: this.parseEstimatedLoadingToIso(attrs.estimatedLoading),
        quantity_of_pallets: attrs.needs_pallets ? (attrs.quantity_of_pallets ?? 0) : 0,
        driver_commission: attrs.driver_commission || null,
        needs_pallets: attrs.needs_pallets === true,
        freight_kind: attrs.freight_kind || driverAttrs.freight_kind_default || null,
        payment_method: payment,
      }
    },
    prepareOrderShippingPrice() {
      const orderShippingPrice = this.new_order.items_attributes.reduce((acc, item) => {
        const bags = Number(item.total_bags) || 0
        const unitShip = Number(String(item.unit_shipping_price || 0).replace(/,/g, '')) || 0
        return acc + (bags * unitShip)
      }, 0)
      const totalBags = Number(this.new_order.total_order_bags) || 0

      this.new_order.order_shipping_price = orderShippingPrice
      this.new_order.bag_shipping_price = totalBags > 0
        ? (orderShippingPrice / totalBags).toFixed(4)
        : '0.0000'
    },
    prepareOrder(){
      this.prepareShipping()
      this.prepareDriverTruck()
      this.prepareDeliveryData()
      this.prepareOrderShippingPrice()
    },
    createOrder(){
      if(this.validateStepper(this.last_stepper)){
        this.swallConfirmation({ title: 'Deseja criar pedido?', icon: 'question' }).then( confirmed =>{
          if (confirmed ) {
            this.new_order.client_wants_email = 'dont_want'
            this.prepareOrder()
            this.saving = true
            Api.Order.create( this.new_order ).then( ( res ) => {
              this.addNotification({type: 'success', msg: 'Criado com sucesso!'})
              this.$emit('created', { id: res.data?.id, solution: 'wholesale' })
            }).finally(()=> {
              this.saving = false
            })
          }
        })
      }
    },
    loadPaymentTimes() {
      Api.PaymentOption.index('times').then(r => r.data).then(pay => {
        this.all_pay_times = [...pay.data.map(el => ({ ...el, id: parseInt(el.id) }))]
      }).catch(() => {})
    },
  },
  mounted() {
    this.loadPaymentTimes()
  },
  watch:{
    "new_order.without_client"(nv){
      this.handleWithoutClient()
      this.handleCanUseClient(nv)
    },
    "new_order.modality_id"(nv, ov){
      if (nv != ov && ov != null){
        this.new_order.client_id = null
      }
    }
  }
}
</script>